export const GET_USER_COINS = 'GET_USER_COINS'
export const FETCH_AVATAR_URL = 'FETCH_AVATAR_URL'
export const GET_ALL_STORYBOOKS = 'GET_ALL_STORYBOOKS'
export const FETCH_LOADING = "FETCH_LOADING"
export const FETCH_FAILED = "FETCH_FAILED"